$(document).ready(function () {
    $('.free-membership').find('a').click(function (e) {
        var form = $('#crewards-signup-form');
        if (form != null && form != undefined) {
            e.preventDefault()

            $('html, body').animate(
                {
                    scrollTop: form.offset().top - 200,
                },
                500,
                'linear'
            )
        }
    });
});
